module.exports = __webpack_public_path__ + "img/tmak_overview.1ef6109e.png";